import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import GalleryPage from "./pages/GalleryPage";
import PricingPage from "./pages/PricingPage";
import BookingPage from "./pages/BookingPage";
import ReviewsPage from "./pages/ReviewsPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import "./App.css";

function App() {
  return (
    <div className="App bg-[#050505] min-h-screen">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/szolgaltatasok" element={<ServicesPage />} />
            <Route path="/galeria" element={<GalleryPage />} />
            <Route path="/arak" element={<PricingPage />} />
            <Route path="/idopontfoglalas" element={<BookingPage />} />
            <Route path="/velemenyek" element={<ReviewsPage />} />
            <Route path="/rolunk" element={<AboutPage />} />
            <Route path="/kapcsolat" element={<ContactPage />} />
          </Routes>
        </Layout>
        <Toaster 
          position="top-right"
          toastOptions={{
            style: {
              background: '#121212',
              color: '#E5E5E5',
              border: '1px solid #2A2A2A',
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
